import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0e61d782"),n=n(),_popScopeId(),n)
const _hoisted_1 = { temp: "f" }
const _hoisted_2 = { class: "detail-head flex" }
const _hoisted_3 = { class: "detail-item" }
const _hoisted_4 = { class: "detail-item" }
const _hoisted_5 = { class: "detail-item" }
const _hoisted_6 = { class: "detail-item" }
const _hoisted_7 = { class: "detail-item" }
const _hoisted_8 = { class: "detail-item" }
const _hoisted_9 = { class: "detail-item" }
const _hoisted_10 = { class: "detail-item" }
const _hoisted_11 = { class: "table" }
const _hoisted_12 = { class: "table-thead" }
const _hoisted_13 = ["width"]
const _hoisted_14 = { class: "table-body" }
const _hoisted_15 = ["src"]
const _hoisted_16 = { key: 2 }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_18 = { key: 0 }
const _hoisted_19 = {
  key: 1,
  style: {"text-align":"left"}
}
const _hoisted_20 = { class: "flex-bwn mb_5" }
const _hoisted_21 = { class: "flex-bwn mb_5" }
const _hoisted_22 = { class: "flex-bwn mb_5" }
const _hoisted_23 = { class: "flex-bwn mb_5" }
const _hoisted_24 = { class: "flex-bwn mb_5" }
const _hoisted_25 = { class: "flex-bwn mb_5" }
const _hoisted_26 = { style: {"max-width":"50%"} }
const _hoisted_27 = { key: 4 }
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_29 = { key: 5 }

import { t } from '@/plugins/i18n'
import { ref, reactive, computed, watch } from 'vue'
import { getJapanTime } from '@/util/common'
import { formatPrice, plusPrice, reducePrice, setFixed2 } from './data'
import { BASE_IMAGE } from '@/common/baseImage'
import { isMultiStore, isJA } from '@/store'
import { showCurrentUnit } from '@/util/useYan'


export default /*#__PURE__*/_defineComponent({
  props: {
  visible: {
    type: Boolean,
    default: false
  },
  rowName: {
    type: String,
    default: ''
  },
  rowItemDetail: {
    type: Object,
    default: () => ({})
  },
  type: {
    type: Number,
    default: 1
  }
},
  setup(__props) {

const props = __props

// 当前币种对应的单位
const currencyCodeUnit = computed(() => {
  return showCurrentUnit(isMultiStore() && props.rowItemDetail?.currencyCode === 'KRW')
})

const columns = [
  { prop: 'productImg', label: t('商品图片') },
  { prop: 'productSku', label: t('平台商品SKU') },
  { prop: 'productTitle', label: t('商品名称'), width: 180 },
  { prop: 'allPrice', label: t('全包价'), width: 100 },
  { prop: 'feeDetail', label: t('全包价明细'), width: 260 },
  { prop: 'orderQuantity', label: t('补扣数量'), width: 100 },
  { prop: 'totalPrice', label: t('补扣总金额'), width: 110 }
]


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("p", _hoisted_3, [
        _createElementVNode("span", null, _toDisplayString(_unref(t)('THE CKB订单编号')) + "：", 1),
        _createElementVNode("span", null, _toDisplayString(__props.rowItemDetail?.platformOrderNo ?? ''), 1)
      ]),
      _createElementVNode("p", _hoisted_4, [
        _createElementVNode("span", null, _toDisplayString(_unref(t)('结算总价')) + "：", 1),
        _createElementVNode("span", null, "-" + _toDisplayString(__props.rowItemDetail?.changeAmount), 1)
      ]),
      _createElementVNode("p", _hoisted_5, [
        _createElementVNode("span", null, _toDisplayString(_unref(t)('可用余额')) + "：", 1),
        _createElementVNode("span", null, _toDisplayString(_unref(formatPrice)(__props.rowItemDetail?.afterAvailableAmount)) + _toDisplayString(_unref(currencyCodeUnit)), 1)
      ]),
      _createElementVNode("p", _hoisted_6, [
        _createElementVNode("span", null, _toDisplayString(_unref(t)('日期')) + "：", 1),
        _createElementVNode("span", null, _toDisplayString(_unref(getJapanTime)(__props.rowItemDetail?.createTime)), 1)
      ])
    ]),
    _createElementVNode("div", null, [
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("b", null, _toDisplayString(_unref(t)('费用类型')) + " : ", 1),
        _createElementVNode("span", null, _toDisplayString(__props.rowName) + "(" + _toDisplayString(__props.rowItemDetail?.bizContentCustomer) + ")", 1)
      ]),
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("b", null, _toDisplayString(_unref(t)('结算总数量')) + " : ", 1),
        _createElementVNode("span", null, _toDisplayString(__props.rowItemDetail?.platformOrderProductSettleDetail?.itemSettleList?.reduce((acc, v) => {
          return acc + (v.settlementQuantity - v.sellQuantity)
        }, 0)), 1)
      ]),
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("b", null, _toDisplayString(_unref(t)('补扣金额')) + " : ", 1),
        _createElementVNode("span", null, _toDisplayString(__props.rowItemDetail?.originChangeAmount) + "円(" + _toDisplayString(__props.rowItemDetail?.changeAmount) + "元)", 1)
      ]),
      _createElementVNode("div", _hoisted_10, [
        _createElementVNode("b", null, _toDisplayString(_unref(t)('物流方式')) + " : ", 1),
        _createElementVNode("span", null, _toDisplayString(__props.rowItemDetail?.platformOrderProductSettleDetail?.transportType === 1 ? _unref(t)('海运') : _unref(t)('空运')), 1)
      ])
    ]),
    _createElementVNode("div", null, [
      _createElementVNode("table", _hoisted_11, [
        _createElementVNode("thead", _hoisted_12, [
          _createElementVNode("tr", null, [
            (_openBlock(), _createElementBlock(_Fragment, null, _renderList(columns, (item) => {
              return _createElementVNode("th", {
                key: item.prop,
                width: item.width
              }, _toDisplayString(item.label), 9, _hoisted_13)
            }), 64))
          ])
        ]),
        _createElementVNode("tbody", _hoisted_14, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList((__props.rowItemDetail.platformOrderProductSettleDetail?.itemSettleList || []), (row) => {
            return (_openBlock(), _createElementBlock("tr", {
              key: row.productSku
            }, [
              (_openBlock(), _createElementBlock(_Fragment, null, _renderList(columns, (v) => {
                return _createElementVNode("td", {
                  key: v.prop
                }, [
                  (v.prop === 'productPropertiesName')
                    ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList((row[v.prop] || '').split(';'), (prop) => {
                        return (_openBlock(), _createElementBlock("p", { key: prop }, _toDisplayString(prop.replace(/[+-]?\d+:[+-]?\d+:/, '')), 1))
                      }), 128))
                    : (v.prop === 'productImg')
                      ? (_openBlock(), _createElementBlock("img", {
                          key: 1,
                          referrerPolicy: "no-referrer",
                          src: row[v.prop],
                          alt: "",
                          style: {"width":"60px"}
                        }, null, 8, _hoisted_15))
                      : (v.prop === 'allPrice')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                            _createTextVNode(_toDisplayString(row.allIncludeProductPriceExchange) + "円", 1),
                            _hoisted_17,
                            _createTextVNode("（" + _toDisplayString(row.allIncludeProductPrice) + "元） ", 1)
                          ]))
                        : (v.prop === 'feeDetail')
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                              (row.allIncludeType === 2)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_18, " - "))
                                : (_openBlock(), _createElementBlock("div", _hoisted_19, [
                                    _createElementVNode("div", _hoisted_20, [
                                      _createElementVNode("div", null, _toDisplayString(_unref(t)('商品代金')) + "： ", 1),
                                      _createElementVNode("div", null, _toDisplayString(row.productPriceExchange) + "円 （" + _toDisplayString(row.actualProductSellPrice) + "元） ", 1)
                                    ]),
                                    _createElementVNode("div", _hoisted_21, [
                                      _createElementVNode("div", null, _toDisplayString(_unref(t)('商品附加项')) + "：", 1),
                                      _createElementVNode("div", null, _toDisplayString(row.productAdditionPriceExchange) + "円 （" + _toDisplayString(row.productAdditionPrice) + "元）", 1)
                                    ]),
                                    _createElementVNode("div", _hoisted_22, [
                                      _createElementVNode("div", null, _toDisplayString(_unref(t)('手续费')) + "：", 1),
                                      _createElementVNode("div", null, _toDisplayString(row.defaultAdditionPriceExchange) + "円 （" + _toDisplayString(row.defaultAdditionPrice) + "元）", 1)
                                    ]),
                                    _createElementVNode("div", _hoisted_23, [
                                      _createElementVNode("div", null, _toDisplayString(_unref(t)('国内运费')) + "：", 1),
                                      _createElementVNode("div", null, _toDisplayString(row.innerShipPriceExchange) + "円 （" + _toDisplayString(row.innerShipSinglePrice) + "元）", 1)
                                    ]),
                                    _createElementVNode("div", _hoisted_24, [
                                      _createElementVNode("div", null, _toDisplayString(_unref(t)('国际物流费用')) + "：", 1),
                                      _createElementVNode("div", null, _toDisplayString(row.allIncludeShipPriceExchange) + "円 （" + _toDisplayString(row.allIncludeShipPrice) + "元）", 1)
                                    ]),
                                    _createElementVNode("div", _hoisted_25, [
                                      _createElementVNode("div", _hoisted_26, _toDisplayString(_unref(t)('关税1')) + "：", 1),
                                      _createElementVNode("div", null, _toDisplayString(row.allIncludeTaxPriceExchange) + "円 （" + _toDisplayString(row.allIncludeTaxPrice) + "元）", 1)
                                    ])
                                  ]))
                            ], 64))
                          : (v.prop === 'totalPrice')
                            ? (_openBlock(), _createElementBlock("span", _hoisted_27, [
                                _createTextVNode(_toDisplayString((row.allIncludeProductPriceExchange * (row.settlementQuantity - row.sellQuantity)).toFixed(0)) + "日元", 1),
                                _hoisted_28,
                                _createTextVNode("（" + _toDisplayString((row.allIncludeProductPrice * (row.settlementQuantity - row.sellQuantity)).toFixed(2)) + "元）", 1)
                              ]))
                            : (v.prop === 'orderQuantity')
                              ? (_openBlock(), _createElementBlock("span", _hoisted_29, _toDisplayString(row.settlementQuantity - row.sellQuantity), 1))
                              : (_openBlock(), _createElementBlock(_Fragment, { key: 6 }, [
                                  _createTextVNode(_toDisplayString(row[v.prop]), 1)
                                ], 64))
                ])
              }), 64))
            ]))
          }), 128))
        ])
      ])
    ])
  ]))
}
}

})